/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
import minify from 'rehype-minify-whitespace';
import visitNode from './visit-node';
import visitChildren from './visit-children';
import { handlers } from './handlers';
import parse5DocumentToHast from 'hast-util-from-parse5';
import documentToHast from 'hast-util-from-dom';
import { defaultMarks, } from 'datocms-structured-text-utils';
export function htmlToStructuredText(html, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var document, tree;
        return __generator(this, function (_a) {
            if (typeof DOMParser === 'undefined') {
                throw new Error('DOMParser is not available. Consider using `parse5ToStructuredText` instead!');
            }
            document = new DOMParser().parseFromString(html, 'text/html');
            tree = documentToHast(document);
            return [2 /*return*/, hastToStructuredText(tree, options)];
        });
    });
}
export function parse5ToStructuredText(document, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var tree;
        return __generator(this, function (_a) {
            tree = parse5DocumentToHast(document);
            return [2 /*return*/, hastToStructuredText(tree, options)];
        });
    });
}
export function hastToStructuredText(tree, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var createNode, rootNode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    minify({ newlines: options.newlines === true })(tree);
                    createNode = function (type, props) {
                        props.type = type;
                        return props;
                    };
                    if (typeof options.preprocess === 'function') {
                        options.preprocess(tree);
                    }
                    return [4 /*yield*/, visitNode(createNode, tree, {
                            parentNodeType: 'root',
                            parentNode: null,
                            defaultHandlers: handlers,
                            handlers: Object.assign({}, handlers, options.handlers || {}),
                            wrapText: true,
                            allowedBlocks: Array.isArray(options.allowedBlocks)
                                ? options.allowedBlocks
                                : ['blockquote', 'code', 'heading', 'link', 'list'],
                            allowedMarks: Array.isArray(options.allowedMarks)
                                ? options.allowedMarks
                                : defaultMarks,
                            allowedHeadingLevels: Array.isArray(options.allowedHeadingLevels)
                                ? options.allowedHeadingLevels
                                : [1, 2, 3, 4, 5, 6],
                            global: __assign({ baseUrl: null, baseUrlFound: false }, (options.shared || {})),
                        })];
                case 1:
                    rootNode = _a.sent();
                    if (rootNode) {
                        return [2 /*return*/, {
                                schema: 'dast',
                                document: rootNode,
                            }];
                    }
                    return [2 /*return*/, null];
            }
        });
    });
}
export { visitNode, visitChildren };
export * from './types';
//# sourceMappingURL=index.js.map